
const HistoireCTA = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-fabre-green to-fabre-teal">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-heading font-bold text-white mb-6">
          Rejoignez notre histoire
        </h2>
        <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          Découvrez nos services et participez à notre mission pour un avenir plus durable
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a 
            href="/nos-services" 
            className="bg-white text-fabre-green px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-colors duration-300 shadow-lg"
          >
            Nos Services
          </a>
          <a 
            href="/contact" 
            className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-fabre-green transition-colors duration-300"
          >
            Nous Contacter
          </a>
        </div>
      </div>
    </section>
  );
};

export default HistoireCTA;
